import {
  Account,
  AccountOverview,
  Activity,
  ManageAccount,
  Statements,
  TaxForms,
  Eligibility,
  Claims,
  Beneficiaries,
} from '@/pages';
import { RouteConfig } from 'vue-router';

export const accountRoutes: RouteConfig = {
  name: 'account',
  path: '/account/:id',
  component: Account,
  redirect: { name: 'overview' },
  children: [
    {
      name: 'overview',
      path: 'overview',
      component: AccountOverview,
    },
    {
      name: 'activity',
      path: 'activity',
      component: Activity,
    },
    {
      name: 'manageAccount',
      path: 'manage-account',
      component: ManageAccount,
    },
    {
      name: 'statements',
      path: 'statements',
      component: Statements,
    },
    {
      name: 'taxForms',
      path: 'tax-forms',
      component: TaxForms,
    },
    {
      name: 'eligibility',
      path: 'eligibility',
      component: Eligibility,
    },
    {
      name: 'claims',
      path: 'claims',
      component: Claims,
    },
    {
      name: 'beneficiaries',
      path: 'beneficiaries',
      component: Beneficiaries,
    },
  ],
};
